import moment from 'moment';

/**
 * Report date presets. The API takes IST calendar days, both inclusive, and
 * treats no dates as yesterday; Lifetime is sent explicitly as range=lifetime.
 */
export const PRESET = {
  YESTERDAY: 'yesterday',
  TODAY: 'today',
  LIFETIME: 'lifetime',
  CUSTOM: 'custom'
};

export const DEFAULT_RANGE = { preset: PRESET.YESTERDAY, from: null, to: null };

const YMD = 'YYYY-MM-DD';

export function rangeParams({ preset, from, to }) {
  switch (preset) {
    case PRESET.TODAY: {
      const today = moment().format(YMD);
      return { from: today, to: today };
    }
    case PRESET.LIFETIME:
      return { range: 'lifetime' };
    case PRESET.CUSTOM:
      return { from: moment(from).format(YMD), to: moment(to).format(YMD) };
    case PRESET.YESTERDAY:
    default: {
      const yesterday = moment().subtract(1, 'day').format(YMD);
      return { from: yesterday, to: yesterday };
    }
  }
}

/** "12 Oct 2026", "1 – 12 Oct 2026", or "All time". */
export function rangeLabel(range) {
  if (range?.lifetime) return 'All time';
  if (!range?.from) return '';
  const from = moment(range.from, YMD);
  const to = moment(range.to, YMD);
  if (from.isSame(to, 'day')) return from.format('D MMM YYYY');
  if (from.isSame(to, 'year')) return `${from.format('D MMM')} – ${to.format('D MMM YYYY')}`;
  return `${from.format('D MMM YYYY')} – ${to.format('D MMM YYYY')}`;
}
